import { CartLineEdge } from '../shopify';

/**
 * Calculates subtotal for a cart line item
 */
export const calculateSubtotal = (
  priceAmount: string | number,
  quantity: number,
) => {
  return parseFloat(String(priceAmount)) * quantity;
};

/**
 * Updates a cart line with new quantity and recalculates subtotal
 */
export const updateCartLineQuantity = (
  edge: CartLineEdge,
  newQuantity: number,
) => ({
  ...edge,
  node: {
    ...edge.node,
    quantity: newQuantity,
    cost: {
      ...edge.node.cost,
      subtotalAmount: {
        ...edge.node.cost.subtotalAmount,
        amount: calculateSubtotal(
          edge.node.merchandise.price?.amount || '0',
          newQuantity,
        ),
      },
    },
  },
});

/**
 * Calculates total quantity from cart line edges
 */
export const calculateTotalQuantity = (edges: any[]) =>
  edges.reduce((total, edge) => total + edge.node.quantity, 0);
